var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-city" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("headquarter")) + "\n\t")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 140 } },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.current_client === "chevrolet"
                        ? _vm.$t("group_name")
                        : _vm.$t("name"),
                    error: _vm.$v.name.$error
                  },
                  on: { input: _vm.$v.name.$touch },
                  model: {
                    value: _vm.name,
                    callback: function($$v) {
                      _vm.name = $$v
                    },
                    expression: "name"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 140 } },
              [
                _c("q-input", {
                  attrs: {
                    "float-label":
                      _vm.current_client === "chevrolet"
                        ? _vm.$t("economic_group")
                        : _vm.$t("fantasy_name"),
                    error: _vm.$v.fantasy.$error
                  },
                  on: { input: _vm.$v.fantasy.$touch },
                  model: {
                    value: _vm.fantasy,
                    callback: function($$v) {
                      _vm.fantasy = $$v
                    },
                    expression: "fantasy"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm.hasDocument
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.document_error,
                      "error-label": _vm.document_error
                        ? _vm.$t("document_not_unique")
                        : ""
                    }
                  },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label":
                          _vm.current_client === "chevrolet"
                            ? _vm.$t("cd_matriz")
                            : _vm.$t("company_document"),
                        error: _vm.$v.document.$error
                      },
                      on: {
                        input: _vm.$v.document.$touch,
                        blur: function($event) {
                          return _vm.documentUnique()
                        }
                      },
                      model: {
                        value: _vm.document,
                        callback: function($$v) {
                          _vm.document = $$v
                        },
                        expression: "document"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                filter: "",
                "autofocus-filter": "",
                options: _vm.company_types,
                "float-label": _vm.$t("organization_type"),
                error: _vm.$v.company_type.$error
              },
              on: { input: _vm.$v.company_type.$touch },
              model: {
                value: _vm.company_type,
                callback: function($$v) {
                  _vm.company_type = $$v
                },
                expression: "company_type"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-list",
        { staticClass: "q-my-md q-pb-md" },
        [
          _c(
            "q-collapsible",
            {
              attrs: {
                icon: "fal fa-map",
                label: _vm.$t("address"),
                dense: ""
              },
              model: {
                value: _vm.has_address,
                callback: function($$v) {
                  _vm.has_address = $$v
                },
                expression: "has_address"
              }
            },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.countries,
                        "float-label": _vm.$t("country"),
                        error: _vm.$v.country.$error
                      },
                      on: { input: _vm.$v.country.$touch },
                      model: {
                        value: _vm.country,
                        callback: function($$v) {
                          _vm.country = $$v
                        },
                        expression: "country"
                      }
                    })
                  ],
                  1
                ),
                _vm.keyGooogleMaps
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.show_maps_alert,
                              "error-label": _vm.$t(
                                "not_found_check_that_the_search_is_spelled_correctly_and_try_to_add_a_street_address_and_the_number_of_valid_addresses"
                              )
                            }
                          },
                          [
                            _c(
                              "q-input",
                              {
                                attrs: {
                                  "float-label": _vm.$t("address"),
                                  autocomplete: "new-password",
                                  error: _vm.$v.address.$error,
                                  placeholder: _vm.$t(
                                    "search_by_name_and_street_number"
                                  )
                                },
                                on: { input: _vm.$v.address.$touch },
                                model: {
                                  value: _vm.address,
                                  callback: function($$v) {
                                    _vm.address = $$v
                                  },
                                  expression: "address"
                                }
                              },
                              [
                                _c("q-autocomplete", {
                                  attrs: { "min-characters": 3, separator: "" },
                                  on: {
                                    search: _vm.getAddressGoogleMaps,
                                    selected: _vm.selectedAddressGoogleMaps
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c(
                          "q-input",
                          {
                            attrs: {
                              "float-label": _vm.$t("address"),
                              autocomplete: "new-password",
                              error: _vm.$v.address.$error
                            },
                            on: { input: _vm.$v.address.$touch },
                            model: {
                              value: _vm.address,
                              callback: function($$v) {
                                _vm.address = $$v
                              },
                              expression: "address"
                            }
                          },
                          [
                            _c("q-autocomplete", {
                              attrs: { "min-characters": 3, separator: "" },
                              on: {
                                search: _vm.getAddress,
                                selected: _vm.selectedAddress
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-4" },
                  [
                    _c("q-input", {
                      ref: "number",
                      attrs: { "float-label": _vm.$t("number") },
                      model: {
                        value: _vm.number,
                        callback: function($$v) {
                          _vm.number = $$v
                        },
                        expression: "number"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-4" },
                  [
                    _c("q-input", {
                      attrs: { "float-label": _vm.$t("complement") },
                      model: {
                        value: _vm.complement,
                        callback: function($$v) {
                          _vm.complement = $$v
                        },
                        expression: "complement"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-4" },
                  [
                    _c("q-input", {
                      attrs: { "float-label": _vm.$t("neighborhood") },
                      model: {
                        value: _vm.neighborhood,
                        callback: function($$v) {
                          _vm.neighborhood = $$v
                        },
                        expression: "neighborhood"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-4" },
                  [
                    _c("q-input", {
                      attrs: { "float-label": _vm.$t("postal_code") },
                      model: {
                        value: _vm.postal_code,
                        callback: function($$v) {
                          _vm.postal_code = $$v
                        },
                        expression: "postal_code"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-4" },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("city"),
                        error: _vm.$v.city.$error
                      },
                      on: { input: _vm.$v.city.$touch },
                      model: {
                        value: _vm.city,
                        callback: function($$v) {
                          _vm.city = $$v
                        },
                        expression: "city"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-4" },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("state"),
                        error: _vm.$v.state.$error
                      },
                      on: { input: _vm.$v.state.$touch },
                      model: {
                        value: _vm.state,
                        callback: function($$v) {
                          _vm.state = $$v
                        },
                        expression: "state"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("status")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorStatus,
                options: _vm.statuses
              },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-my-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_headquarters" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _vm.id
        ? _c(
            "div",
            { staticClass: "q-display-1 q-mb-md text-secondary" },
            [
              _c("q-icon", {
                staticClass: "q-mb-sm",
                attrs: { name: "far fa-building" }
              }),
              _vm._v(" " + _vm._s(_vm.$t("branches")) + "\n\t")
            ],
            1
          )
        : _vm._e(),
      _vm.id
        ? _c("q-table", {
            attrs: {
              data: _vm.branches,
              columns: _vm.columns,
              pagination: _vm.server_pagination,
              loading: _vm.loading,
              filter: _vm.filter,
              "row-key": "name",
              "no-data-label": _vm.$t("no_data_avaliable"),
              "no-results-label": _vm.$t("no_results_found"),
              "loading-label": _vm.$t("loading_data"),
              "rows-per-page-label": _vm.$t("items_per_page"),
              "rows-per-page-options": [5, 10, 50, 100],
              "binary-state-sort": ""
            },
            on: {
              "update:pagination": function($event) {
                _vm.server_pagination = $event
              },
              request: _vm.fetchBranches
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "top",
                  fn: function(props) {
                    return [
                      _c("q-search", {
                        attrs: {
                          icon: "far fa-search",
                          placeholder: _vm.$t("search"),
                          debounce: 500
                        },
                        model: {
                          value: _vm.filter,
                          callback: function($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter"
                        }
                      }),
                      _c("div", { staticClass: "col" }),
                      _c("q-btn", {
                        attrs: {
                          color: "secondary",
                          icon: "far fa-plus",
                          label: _vm.$t("new_f"),
                          disable: _vm.disableNewBranch
                        },
                        on: {
                          click: function($event) {
                            _vm.current_client === "chevrolet"
                              ? _vm.$router.push({
                                  name: "admin_branch",
                                  params: {
                                    id: 0,
                                    id_company: _vm.id,
                                    company_document: _vm.name
                                  }
                                })
                              : _vm.$router.push({
                                  name: "admin_branch",
                                  params: {
                                    id: 0,
                                    id_company: _vm.id,
                                    company_document: _vm.document
                                  }
                                })
                          }
                        }
                      })
                    ]
                  }
                },
                {
                  key: "header",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      _vm._l(props.cols, function(col) {
                        return _c(
                          "q-th",
                          { key: col.name, attrs: { props: props } },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(_vm.$t(col.label)) +
                                "\n\t\t\t"
                            )
                          ]
                        )
                      }),
                      1
                    )
                  }
                },
                {
                  key: "body",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      [
                        _c(
                          "q-td",
                          {
                            key: "id",
                            attrs: { "auto-width": "", props: props }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t"
                            )
                          ]
                        ),
                        _c("q-td", { key: "name", attrs: { props: props } }, [
                          _vm._v(
                            "\n\t\t\t\t" + _vm._s(props.row.name) + "\n\t\t\t"
                          )
                        ]),
                        _c(
                          "q-td",
                          { key: "document", attrs: { props: props } },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(props.row.document) +
                                "\n\t\t\t"
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          { key: "branch_type", attrs: { props: props } },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  _vm.getBranchType(props.row.branch_type)
                                ) +
                                "\n\t\t\t"
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          {
                            key: "status",
                            attrs: { props: props, "auto-width": "" }
                          },
                          [
                            _c(
                              "q-chip",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  small: "",
                                  icon: _vm.getIconStatus(props.row.status),
                                  color: _vm.getColorStatusBranches(
                                    props.row.status
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(_vm.getStatus(props.row.status))
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-td",
                          { key: "actions", attrs: { props: props } },
                          [
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  flat: "",
                                  round: "",
                                  color: "primary",
                                  icon: "far fa-pencil-alt"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$router.push({
                                      name: "admin_branch",
                                      params: {
                                        id: props.row.actions,
                                        id_company: _vm.id
                                      }
                                    })
                                  }
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                      "\n\t\t\t\t\t"
                                  )
                                ])
                              ],
                              1
                            ),
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  flat: "",
                                  round: "",
                                  color: "negative",
                                  icon: "far fa-trash-alt"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.confirmRemove(props.row.actions)
                                  }
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("delete_tooltip")) +
                                      "\n\t\t\t\t\t"
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }
                }
              ],
              null,
              false,
              3257882114
            )
          })
        : _vm._e(),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }